export default __webpack_public_path__ + "static/media/logo-hbs.a1ec9850.svg";